import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  TOKEN_INVALIDO,
  FECHA_MODULOS,
  SELECIONA_MODULOS,
  ATIVA_TESTES,
  CARREGA_PESSOAS_PARA_TESTES,
  CARREGA_PESSOAS_PARA_TESTES_SUCESSO,
  SELECIONA_PESSOA_SIMULACAO,
  EXECUTA_SIMULACAO,
  ATUALIZA_MODO_PORTARIA,
} from 'constants/ActionTypes';

export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER
  };
};

export const userSignOutPortaria = (modo, idAmbientePortaria, idPosicaoPortaria, pontosAcessoSelecionados, idIntervalGerado) => {

  clearInterval(idIntervalGerado);
  
  return [ 
  {
    type: ATUALIZA_MODO_PORTARIA,
    payload: { modo, idAmbientePortaria, idPosicaoPortaria, pontosAcessoSelecionados }
  },
  {
    type: SIGNOUT_USER,
    payload: null
  }
]

};

// Antes calculava aqui se o usuário acessa Portaria/Backoffice a partir de "configuracao"
// (objeto vindo do backend legado) e decidia pra qual módulo ir. Isso mudou de lugar: quem
// decide o módulo agora é sagas/Seguranca.js (decideRoteamentoModulo), a partir do
// contexto carregado de GET /me da Uzerpass.Seguranca — ver
// docs/plano-integracao-api-seguranca.md. Esta action fica só com o essencial do login.
export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: { authUser }
  };
};

export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const fechaModulos = () => {
  return {
    type: FECHA_MODULOS,
    payload: null
  };
};

export const selecionaModulos = () => {
  return {
    type: SELECIONA_MODULOS,
    payload: null
  };
};

export const ativaTestes = () => {

  return [{
    type: CARREGA_PESSOAS_PARA_TESTES
  },
  {
    type: ATIVA_TESTES
  }]
};

export const carregaPessoasParaTestesSucesso = (ambientesPortaria, usuariosPlataforma) => {
  return {
    type: CARREGA_PESSOAS_PARA_TESTES_SUCESSO,
    payload: { ambientesPortaria, usuariosPlataforma }
  };
}

export const selecionaPessoaSimulacao = (idPessoa) => {

  return [{
    type: SELECIONA_PESSOA_SIMULACAO,
    payload: idPessoa
  }]
};

export const executaSimulacao = (idPessoa, idPonto) => {

  if (idPessoa !== 0) {
    return {
      type: EXECUTA_SIMULACAO,
      payload: { idPessoa, idPonto }
    }
  }
}


export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
export const exibeTokenInvalido = () => {
  return {
    type: TOKEN_INVALIDO,
  };
}
